import { createPromiseAction } from 'redux-saga-promise-actions';
import { TopDestination, TopDestinationsFailure } from 'store/types/topDestinations';

export const getTopDestinations = createPromiseAction(
  'GET_TOP_DESTINATIONS',
  'GET_TOP_DESTINATIONS_SUCCEEDED',
  'GET_TOP_DESTINATIONS_FAILURE',
)<undefined, Array<TopDestination>, TopDestinationsFailure>();
